import {
    CasesGeneral,
    CasesGeneralFilter,
} from '../shared/types/modules/cases-general';
import { apiService } from './index';

export const asyncGetCasesGenerals = async (
    filters: CasesGeneralFilter,
    page?: number,
    pageSize?: number
): Promise<{ items: CasesGeneral[]; length: number }> => {
    try {
        const {
            items: data,
        }: {
            items: { items: CasesGeneral[]; length: number };
        } = await apiService.get('/api/cases-general', {
            limit: pageSize || 20,
            page: page || 0,
            ...filters,
        });

        return data || { items: [], length: 0 };
    } catch (error) {
        return { items: [], length: 0 };
    }
};

export const asyncGetCasesGeneral = async (
    idCaseGeneral: string
): Promise<CasesGeneral | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: CasesGeneral;
        } = await apiService.get(`/api/cases-general/${idCaseGeneral}`);

        return data;
    } catch (error) {}
};

export const asyncCreateCasesGeneral = async (
    info: CasesGeneral
): Promise<CasesGeneral | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: CasesGeneral;
        } = await apiService.post('/api/cases-general', info);
        return data;
    } catch (error) {}
};

export const asyncUpdateCasesGeneral = async (
    id: string,
    casesGeneral: CasesGeneral
): Promise<CasesGeneral | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: CasesGeneral;
        } = await apiService.patch(`/api/cases-general/${id}`, casesGeneral);

        return data;
    } catch (error) {}
};
